export const ROUND_CREATE_INIT = 'ROUND_CREATE_INIT';
export const ROUND_CREATE = 'ROUND_CREATE';

export const ROUND_REMOVE_INIT = 'ROUND_REMOVE_INIT';
export const ROUND_REMOVE = 'ROUND_REMOVE';

export const ROUND_BULK_UPDATE = 'ROUND_BULK_UPDATE';
export const ROUND_BULK_UPDATE_INIT = 'ROUND_BULK_UPDATE_INIT';
export const ROUND_BULK_UPDATE_DONE = 'ROUND_BULK_UPDATE_DONE';
